const PATH = 'fe.app';

const messages = {
  skipToMainContent: {
    key: `${PATH}.skip_to_main_content`,
    defaultValue: 'Skip to main content'
  }
};

export default messages;
